import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';

import Grid from '@mui/material/Grid';


import { makeStyles } from '@mui/styles';
 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
 
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});



 

export default class Addstaff extends Component {

  
  
  
  
  constructor(props) {
    super();
	 this.state = {st_id:0,st_isdisplay:false,previocn:'',st_profile:'',stid:'',stidarray:[],open:false,data:[],redirect:false,details:'',erropen:false,showPassword:false,password:'',
	
	 	 logredirect:false,pagename:'',branchdata:[],branch:'',branchlabel:'Select Branch',btndisabled:false,names:'',emailid:'',phoneno:'',address:'',weeklyoff:'',role:'',passwords:'',noofleeavespermitted:'',hidepawd:"",
submitbtn:"Submit" 
      }
   
}



onFileChange=(e) =>{
	   	 
	   
	
	 let imageFile = e.target.files[0];
	 
	   this.setState({ st_profile: e.target.files })
	   
	   
	 
	   	
	
	  
  if (!imageFile.name.match(/\.(png|jpeg|jpg)$/)) {

  this.setState({errormessage:"Please Upload Valid Pic (png,jpeg,jpg).",open:true});
		 window.scrollTo({        top: 0     })
	
  
    return false;
  }else{
        this.setState({ st_profile: e.target.files })
  }
  
		
    }

	
handleisdisplay= (event: React.ChangeEvent<HTMLInputElement>) => {
	
	this.setState({st_isdisplay: event.target.checked});
}


myChangeHandler = (event) => {
 
   const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  if(nam==="phoneno")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  else{
	  
	   this.setState({[nam]: val});
  }
 
  
}

handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

componentWillMount() {
	document.title = "AthaYog Living - Manage Staff";

if(localStorage.getItem("AYLuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
		   this.branchbind(); 
	   let search = window.location.href;
	 let staffid = this.getParameterByName('stid',search);
	if(staffid!==null)
 {
	 axios.get(Serverurl+'ajaxstaff.php?action=getall&st_id='+staffid)
  .then(resp => {  
		
    if(resp.data.length>0){
		let strdisplay=false;
		if(resp.data[0].st_isdisplay=="1")
		{
			strdisplay=true;
		}
			this.setState({  
    names:resp.data[0].st_name,
 emailid:resp.data[0].st_emailid,
phoneno:resp.data[0].st_phoneno,
                address:resp.data[0].st_address,
 			  role: resp.data[0].st_role,  
			  hidepawd: resp.data[0].st_password,  
			  weeklyoff: resp.data[0].st_weeklyoff,  
			  noofleeavespermitted: resp.data[0].st_noofleeavespermitted,  
			  branch: resp.data[0].st_bm_id,  
			  	previocn:resp.data[0].st_profile,
			  	st_isdisplay:strdisplay,
			  st_id:resp.data[0].st_id,
			});
	}

  });
 		
 } 	

}





  handleSubmit= (event) => {
	const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; 
    event.preventDefault();
	let st_id = this.state.st_id;
let names=this.state.names;
    let emailid = this.state.emailid;
    let phoneno = this.state.phoneno;
	 let address = this.state.address;
	  let weeklyoff = this.state.weeklyoff;
    let noofleeavespermitted = this.state.noofleeavespermitted;
    	let role = this.state.role;
	let passwords = this.state.passwords;
let branch = this.state.branch;

let hidepawd = this.state.hidepawd;

	let st_profile=this.state.st_profile;

if(names==="")
{
	this.setState({errormessage:"Please Enter Name",erropen:true});
	return false;
}

 if(emailid==="")
{
	this.setState({errormessage:"Please Enter EmailId.",erropen:true});
	return false;
}else{
	
	 if (!remail.test(emailid)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
  }
}

if(phoneno==="")
{
	this.setState({errormessage:"Please Enter Phoneno",erropen:true});	
	return false;
}

if(role==="")
{
	this.setState({errormessage:"Please Select Role",erropen:true});		
	return false;
}

if(passwords==="" && hidepawd==="")
{
	this.setState({errormessage:"Please Enter Password",erropen:true});	
	return false;
}
if(weeklyoff==="")
{
	this.setState({errormessage:"Please Enter Weeklyoff",erropen:true});	
	return false;
}



if(noofleeavespermitted==="")
{
	this.setState({errormessage:"Please Enter No leave Permitted",erropen:true});	
	return false;
}


/*
if(branch==="")
{
	this.setState({errormessage:"Please Select Branch",erropen:true});	
	return false;
}
*/
let strisdisplay=0;
if(this.state.st_isdisplay===true)
{
	strisdisplay=1;
}

 
 this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  if(this.state.st_id!==0)
	 {
	  
	  formData.append('st_id',this.state.st_id)
	 }else
	 {
		formData.append('st_id',0)  
	 }
	 

	 formData.append('action','insertorupdate')	 
	 
	 
			
	 	   				
			
	if(st_profile!=="")
	  {
		
		for (const key of Object.keys(this.state.st_profile)) {
            formData.append('Filedata', this.state.st_profile[key])
        }
 	
	   formData.append('st_profile','1')		
	  }else
	  {
		 formData.append('st_profile',this.state.previocn)	  
	  
	  }
	
	
	 
    formData.append('st_name',names)
	 formData.append('st_emailid',emailid)
		   formData.append('st_phoneno',phoneno)
	   formData.append('st_address',address)
	   
	   
	   
		 formData.append('st_role',role)

	  formData.append('st_password',passwords)
	  		 formData.append('st_weeklyoff',weeklyoff)
	   formData.append('st_noofleeavespermitted',noofleeavespermitted)
	   formData.append('st_bm_id',branch)
	   formData.append('st_isdisplay',strisdisplay)
	  
	   
	   

		
	   
	   
	  formData.append('userid',localStorage.getItem("AYLuserid"))
	  
	 axios.post(Serverurl+"ajaxstaff.php", formData, {
        }).then(res => {
				if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Email id Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;
 this.setState({btndisabled:false,
	 submitbtn:"Submit"});
	}else{
			
					 this.setState({btndisabled:false,
	 submitbtn:"Submit",redirect:true, pagename:'/Adminstaff'}); 
	}	 
            });
        
  };

branchbind(){

    axios.get(Serverurl+'ajaxbranch.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let BranchApi = resp.data.map(row => {
                      
          return {value: row.bm_id, display:row.bm_name}
        });
		
		 this.setState({
          branchdata: [{value: '', display:'Select Branch'}].concat(BranchApi)
        },()=>{console.log(this.state.branchdata)});
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}



 
  handleClickShowPassword = () => {
    
	this.setState({
            showPassword: !this.state.showPassword
          })
  };
	
	  handleMouseDownPassword = event => {
    event.preventDefault();
  };
 



  
  
  render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  

  
  return (
 
		<React.Fragment>
		
<div className="mainheading"><h1>Manage Yoga Trainer</h1></div>
<div className="addandbacbtn"><NavLink  to="/Adminstaff" >Back</NavLink></div>
<div className="clear"></div>

  <p>   <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    
 
	
<div className="formmain">

<ul>
  
<li>  
		  <p><span className="validation">*</span> Name</p>
		 
		<p>
		<TextField name="names" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.names} className="txtbox"
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
 
 </li>
 
  
<li>  <p><span className="validation">*</span> Email Id:</p>
		<p> <TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.emailid} className="txtbox"
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p></li>

	  
<li>	  <p ><span className="validation">*</span> Phone No. : </p>
		  
		  <p > 
		  
		  
		 <TextField name="phoneno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.phoneno} className="txtbox"
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:10}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p></li>
		  
		  
	
		  
<li>  
		  <p><span className="validation">*</span>Role</p>
		 
		<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="role"
		   value={this.state.role}
		  name="role"
		inputProps={{tabIndex: "4"}}
        >
	<option value={0}>Select Role</option>
	<option value={1}>Admin</option>
	<option value={2}>Manager</option>	
	<option value={3}>Yoga Trainer</option>
<option value={4}>Center Admin</option>	
        </Select>

		</FormControl>
		</p>
 
 </li>		 
		
 <li>	  <p ><span className="validation">*</span>Password : </p>
		  
		  <p> 
		  <FormControl fullWidth  variant="outlined">
 
          <OutlinedInput value={this.state.passwords}
            id="password" name="passwords" 
			
			type={this.state.showPassword ? 'text' : 'password'}
            onChange={this.myChangeHandler}
			inputProps={{tabIndex: "3",maxLength:15}} InputLabelProps={{ shrink: true }}  
			size="small"
            endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}  >
				  { this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
           />
         
        </FormControl>
		 
		  
		 
		  </p></li>
 
 <li>
 
 <p><span className="validation">*</span>Weeklyoff</p>
		  
		  						 <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} className="txtbox"
          id="weeklyoff"
		   value={this.state.weeklyoff}
		  name="weeklyoff"
		inputProps={{tabIndex: "6"}}
        >
	<option value={""}>Select Weekly Off</option>
          <option value={0}>Monday</option>
          <option value={1}>Tuesday</option>
          <option value={2}>Wednesday</option>
		  <option value={3}>Thursday</option>
		   <option value={4}>Friday</option>
		  <option value={5}>Saturday</option>
		  <option value={7}>Sunday</option>	
        </Select>

		</FormControl>
		 </p>     	
		  		  
		</li>
		
		
		  
	<li>
 <p><span className="validation">*</span>No. of Leaves Permitted </p>
		  
		  
		    <p> <TextField name="noofleeavespermitted" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.noofleeavespermitted} className="txtbox"
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "7",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          />
 
		  </p></li>
		  <li>
		  <p>Branch</p>
		  <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branch}}
          onChange={this.myChangeHandler}
          id="branch"
		   value={this.state.branch} className="txtbox"
		  name="branch"
		inputProps={{tabIndex: "8"}}
		
        >
		{this.state.branchdata.map(br => (
            <option  
            
              value={br.value}
            >
              {br.display}
            </option  >
          ))}
		
        </Select></FormControl>
		</p>
		  </li>
		  
		  
		  	   
		<li><p>  <div className="uploadbtn">	  
		  

	<Button component="label"  className="iconuploadbtn" name="st_profile"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<CloudUploadIcon />}>
	
		Upload Profile Image
		<VisuallyHiddenInput type="file"   /></Button>
		{this.state.previocn!="" && (
		<p><a href={Serverurl+"uploads/"+this.state.previocn} target="_blank">View</a></p>
		)}
	</div></p></li>
		   
		   
		   
		
		   
		 <li>	
	  <p> Address: </p>
		  
		   <p > 
		   	  
	 <TextField name="address" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.address} 
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "9",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>
		  
		 </li>    	<li> 
		 <p>Display in Dashboard
		  <Checkbox  
		  
		 
	   fullWidth
	   
         onChange={this.handleisdisplay}
	   value={this.state.st_isdisplay} 
			 name="st_isdisplay"
			 checked={this.state.st_isdisplay}
			  inputProps={{tabIndex: "10",maxLength:150}} 

		  
		   /></p></li>
		 
	
		 
</ul>
	
</div>
	<p className="aligncentr"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
  {this.state.submitbtn}
</Button></p>

</React.Fragment>
  );
  }
}